import React from 'react';
import { LangContext } from '../contexts/lang.context';
import { Box } from '@material-ui/core';

export const IntroSection: React.FC = () => {
  const { APP } = React.useContext(LangContext).currentLangData;

  return (
    <>
      <Box
        // textAlign="center"
        whiteSpace="pre-wrap"
        fontSize="1.6rem"
        fontWeight="500"
        color="#555"
        mt={-2}
        mb={2}
      >
        {APP.introTitle}
      </Box>
      <Box
        // textAlign="center"
        whiteSpace="pre-wrap"
        color="#555"
        fontSize="1.2rem"
        mb={-2}
      >
        {APP.introBody}
      </Box>
    </>
  );
};
